import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BookingList from './BookingList';
import EmailProcessor from './EmailProcessor';

const Booking = () => {
  return (
    <Routes>
      <Route index element={<BookingList />} />
      <Route path="list" element={<BookingList />} />
      <Route path="email-processor" element={<EmailProcessor />} />
      {/* Future booking-related routes can be added here */}
    </Routes>
  );
};

export default Booking;